
<script>
    import { selectedItem } from '../../../store/store.js';
    import { displayInt, displayBoolean } from '../../../utils/utils.js';
</script>

<div class="key-value-table box">
    <h5>Grundinformation</h5>
    <table>
        <colgroup>
            <col style="width: 65%;">
            <col style="width: 30%;">
            <col style="width: 5%;">
        </colgroup>
        <tbody>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Energideklaration utförd</h6>
                </td>
                <td class="column2">
                <h6>{ $selectedItem.energy_year }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Energideklarations-ID</h6>
                </td>
                <td class="column2">
                <h6>{ $selectedItem.energy_declaration_id }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Fastighetsbeteckning</h6>
                </td>
                <td class="column2">
                <h6>{ $selectedItem.fastighetsbeteckning }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Typkod</h6>
                </td>
                <td class="column2">
                <h6>{ $selectedItem.typkod }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Radonhalt</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem.radon_concentration) } Bq/m³</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Typ av ventilationssystem</h6>
                </td>
                <td class="column2">
                <h6>{ $selectedItem.type_of_ventilation_system }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Godkänt ventilationssystem</h6>
                </td>
                <td class="column2">
                <h6>{ displayBoolean($selectedItem.ventilation_control_approved) }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
        </tbody>
    </table>
</div>